<template>
  <div class="nav">
    <div class="nav-brand">
      <img class="nav-brand__logo" src="@/assets/img/cZerologo.png" />
      <p class="nav-brand__title">Buy Now, Pay Later</p>
    </div>
    <div
      class="nav-close"
      v-if="store.state.component !== 'failure-modal' && store.state.component !== 'success-modal'"
      @click="closeModal"
    >
      X
    </div>
  </div>
</template>

<script lang="ts" setup>
import store from '@/composables/useZeroWidgetStore/methods'
const emit = defineEmits<{
  (e: 'close-modal'): void
}>()

const closeModal = () => {
  if (store.state.component === 'failure-modal') {
    store.actions.setComponent('review-payment')
  }
  return emit('close-modal')
}
</script>
